export default __webpack_public_path__ + "static/media/Sight Machine.38c898d1.png";